export default {
  remarks: '备注',
  totalPre: '共',
  totalFix: '笔',
  sort: '排序',
  ascending: '升序',
  descending: '降序',
  collapse: '收起',
  uncollapse: '全部展开',
  addByName: '创建人员',
  adddate: '创建时间',
  updateByName: '更改人员',
  upddate: '更改时间'
}
